import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectLogisticsConfigurationsQueryItem } from '../../../../../redux/logistics-Configurations/selector';
import LogisticsComponent from '../components/logistics-configuration';
import PageLoader from '../../../../../components/PageLoader';
import { selectListItems } from '../../../../../redux/library/selector';
import { logisticsConfigurations } from '../../../../../redux/logistics-Configurations/action';

const ManagementLogisticsConfiguration = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const queryData = useSelector(selectLogisticsConfigurationsQueryItem)
    const libraryData = useSelector(selectListItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [
        selectLogisticsConfigurations,
        setSelectLogisticsConfigurations
    ] = useState<any>([])

    const fetchQueryById = async () => {
        await dispatch(logisticsConfigurations.resetAction({ actionType: 'query' }))
        await dispatch(logisticsConfigurations.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/logistics/query`, entity: 'logistics', jsonData: {

                Records: [
                    {
                        Id: 0
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        })




    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectLogisticsConfigurations({ ...selectLogisticsConfigurations, [fields[0]]: value });

    }
    useEffect(
        () => {

            fetchQueryById()
            setIsLoading(false)

        },
        []
    )

    useEffect(
        () => {

            if (isQuery) {
                const logisticsQueryData = {
                    Id: queryData?.result?.items?.Id || 0,
                    LogisticsmConfigurations: {
                        LogisticsOrderType: queryData?.result?.items?.LogisticsmConfigurations?.LogisticsOrderType,
                        IsUsedForRetail: queryData?.result?.items?.LogisticsmConfigurations?.IsUsedForRetail
                    },
                    ParcelPaymentMethod: {
                        IsOnlineOrder: queryData?.result?.items?.LogisticsmConfigurations?.ParcelPaymentMethod?.IsOnlineOrder,
                        IsCODOrder: queryData?.result?.items?.LogisticsmConfigurations?.ParcelPaymentMethod?.IsCODOrder
                    },
                    CargoPaymentMethod: {
                        IsOnlineOrder: selectLogisticsConfigurations?.LogisticsmConfigurations?.CargoPaymentMethod?.IsOnlineOrder,
                        IsCODOrder: queryData?.result?.items?.LogisticsmConfigurations?.CargoPaymentMethod?.IsCODOrder
                    }
                }
                setSelectLogisticsConfigurations(logisticsQueryData)

            }
        },
        [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        await dispatch(logisticsConfigurations.resetAction({ actionType: 'update' }))
        await dispatch(logisticsConfigurations.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configurations/logistics`, entity: 'logistics', jsonData: {

                Records: [
                    {
                        Id: selectLogisticsConfigurations?.Id,
                        LogisticsmConfigurations: {
                            LogisticsOrderType: selectLogisticsConfigurations?.LogisticsmConfigurations?.LogisticsOrderType || '',
                            IsUsedForRetail: selectLogisticsConfigurations?.LogisticsmConfigurations?.IsUsedForRetail || false,
                            ParcelPaymentMethod: {
                                IsOnlineOrder: selectLogisticsConfigurations?.ParcelPaymentMethod?.IsOnlineOrder || false,
                                IsCODOrder: selectLogisticsConfigurations?.ParcelPaymentMethod?.IsCODOrder || false
                            },
                            CargoPaymentMethod: {
                                IsOnlineOrder: selectLogisticsConfigurations?.CargoPaymentMethod?.IsOnlineOrder || false,
                                IsCODOrder: selectLogisticsConfigurations?.CargoPaymentMethod?.IsCODOrder || false
                            },

                        }
                    }
                ]

            }
        }))
            .then(() => {
                back()
            })
    }

    const back = () => {
        navigate('/management/configurations/logistics')
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <LogisticsComponent
                    logisticsOrderType={libraryData?.result?.LogisticsOrderType}
                    handleInnerFormChange={handleInnerFormChange}
                    selectLogisticsConfigurations={selectLogisticsConfigurations}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                />
            }
        </>
    )

}

export default ManagementLogisticsConfiguration;